import { queryOptions } from '@tanstack/react-query';

import { osAllocationApi } from '../apis/os-allocation';
import { OsAllocationParams } from '../types/os-allocation';

import { Globals, getQueriesWithGlobal, useQueriesWithGlobal } from '@data-access';

export const osAllocationQueries = (global: Globals) => ({
  all: () => [global, 'os-allocation'] as const,
  simulation: (params: OsAllocationParams = {}) =>
    queryOptions({
      queryKey: [...osAllocationQueries(global).all(), params],
      queryFn: () => osAllocationApi.get(params),
    }),
});

export const useOsAllocationQueries = () =>
  useQueriesWithGlobal(osAllocationQueries);

export const getOsAllocationQueries = () =>
  getQueriesWithGlobal(osAllocationQueries);
